import SweetAlert from 'src/class/Alerts';
import PermissionFactory from '../factories/PermissionFactory';
import i18n from "../i18n";

const mixinPermissions = {
  methods: {
    isSuper() {
      return this.$store.state.auth.permissions.includes('Super Administrador');
    },

    isAdmin() {
      return this.$store.state.auth.user.roles[0].type === 'administrador'
    },

    isIndex() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes('Indexar') ||
        this.isHavePermission('index')
      );
    },

    isShow() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes('Visualizar') ||
        this.isHavePermission('index')
      );
    },

    isCreate() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes('Crear') ||
        this.isHavePermission('store')
      );
    },

    isUpdate() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes('Editar') ||
        this.isHavePermission('update')
      );
    },

    isDelete() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes('Borrar') ||
        this.isHavePermission('destroy')
      );
    },

    isPDF() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes('Exportar PDF')
      );
    },

    isExcel() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes('Exportar Excel')
      );
    },

    isExcelSM() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes('Exportar SM')
      );
    },

    isManagementRole() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes('Gestionar Perfil')
      );
    },

    isManagementPermissions() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes('Gestionar Permisos')
      );
    },

    isManagementPassword() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes('Gestionar Password')
      );
    },

    isManagementSession() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes('Gestionar Sesión')
      );
    },

    isClimateForecast() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes(
          'Reporte Pronóstico Climático'
        )
      );
    },

    closings() {
      return (
        this.isSuper() || this.$store.state.auth.permissions.includes('Cierres')
      );
    },

    isAdminPocket() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes(
          'Administrar Tipos De Capturas'
        ) ||
        this.$store.state.auth.user.roles[0].type === 'administrador'
      );
    },

    isRingingCatchAdmin() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes(
          'Administrar Capturas De Edades'
        ) ||
        this.$store.state.auth.user.roles[0].type === 'administrador'
      );
    },

    enabledCurrent() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes('Habilitar Presentes')
      );
    },

    enabledPremature() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes('Habilitar Prematuros')
      );
    },

    enabledChipped() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes('Habilitar Debunchados')
      );
    },

    journalColumnIsEnabled(indexColumn) {
      let analog = {};
      Array.from({ length: 15 }, (_, i) => i + 1).forEach((i) => {
        const index = `week_${i}`;
        analog[index] = `Habilitar Captura ${i} Sem`;
      });

      analog = {
        ...{
          youths: 'Habilitar Captura Jóvenes',
          bacotas: 'Habilitar Captura Bacotas',
        },
        ...analog,
      };
      const permission = analog[indexColumn];

      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes(permission)
      );
    },

    editWiltingSaturationPoints() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes(
          'Puntos De Marchitez Y Saturación'
        )
      );
    },

    editBaseTempThreshold() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes(
          'Temperatura Base y Umbral Superior'
        )
      );
    },

    showHeatAccumulatorData() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes(
          'Embolse - Acumulador de Calor'
        )
      );
    },

    isHavePermission(suffix) {
      let permissions = new PermissionFactory(this).getPermission('permission');
      permissions.setStorePermissions();
      return permissions.validateHavePermission(
        this.$route.meta.prefix_permission + '.' + suffix
      );
    },

    showMessageAccess() {
      SweetAlert.warning(
        i18n.t('uti.mixinPermissions.noPermissions')
      );
    },

    isExportDetailAdvancedAudit() {
      return (
        this.isSuper() ||
        this.$store.state.auth.permissions.includes(
          'Exportar Detalle Auditoria+'
        )
      );
    },
  },
};

export default mixinPermissions;
